Ext.define('ViewPojazdy', {
    extend: 'Ext.panel.Panel',
    grid: null,
    gridpage: null,
    windowObject: null,
    id: "pojazdy",
    taskContextMenu: null,
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyName: "access.manage.pojazdy",
        accessPropertyViewName: "access.view.pojazdy",
        accessPropertyWynajemName: "access.manage.pojazdy_wynajem",
        accessPropertyViewWynajemName: "access.view.pojazdy_wynajem"
    },
    cat: "k",
    text: Lang.pojazdy,
    buttonIconCls: "iconPojazd",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                id: this.id + "bnew",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Const.ENABLEKELLER ? Lang.nowy_wlasny.capitalise() : Lang.nowy.capitalise(),
                scope: this,
                handler: this.dodajObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update")
            }, {
                id: this.id + "bnewwynajem",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy_wynajem.capitalise(),
                scope: this,
                hidden: !Const.ENABLEKELLER,
                handler: this.dodajObiektWynajem,
                disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/update")
            }, {
                id: this.id + "bedit3",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.klonowanie.capitalise(),
                scope: this,
                handler: this.edytujObiekt2,
                disabled: (!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add") && !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add")),
            }, {
                id: this.id + "bedit",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.edytuj.capitalise(),
                scope: this,
                handler: this.edytujObiekt,
                disabled: (!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update") && !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/update")),
            }, {
                xtype: 'button',
                id: this.id + "masseditbtn",
                iconAlign: 'left',
                iconCls: 'iconEdit',
                text: Lang.edycja_zbiorcza,
                scope: this,
                handler: this.massEdit,
                hidden: Const.STARTERFLAG || Const.ENABLEKELLER,
                disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update")
            }, {
                id: this.id + "bdelete",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconDelete",
                text: Lang.usun.capitalise(),
                scope: this,
                handler: this.usunObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/delete") || Const.ENABLEKELLER
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconPDF",
                text: Lang.pdf.capitalise(),
                scope: this,
                handler: this.getDownloadLsPdf
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEXCEL",
                text: Lang.excel.capitalise(),
                scope: this,
                handler: this.getDownloadLsExcel
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: 'button',
                id: this.id + "grupybtn",
                iconAlign: 'left',
                iconCls: 'iconGroup',
                text: Lang.grupy,
                scope: this,
                handler: this.showGrupy,
                hidden: !validPrivilegesOperatorComplex(WindowGroups.accessPropertyName) || Const.STARTERFLAG
            }, {
                xtype: 'button',
                id: this.id + "kategoriebtn",
                iconAlign: 'left',
                iconCls: 'iconGroup',
                text: Lang.kategorie,
                scope: this,
                handler: this.showKategorie,
                hidden: !validPrivilegesOperatorComplex(WindowKategorie.accessPropertyName) || Const.STARTERFLAG
            }, {
                xtype: "box",
                id: this.id + "kontekstfirmybox",
                cls: "kontekstfirmy-box"
            }, {
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                style: 'display:block;margin-right:5px',
                cls: "kontekstfirmy-text"
            }, {
                xtype: 'tbseparator',
                hidden: (!Const.BASICFLAG && !Const.STANDARDFLAG && !Const.STARTERFLAG) || Const.LICENCE.SERVER_LIMITOFF_KDPANDID
            }, {
                xtype: 'label',
                hidden: (!Const.BASICFLAG && !Const.STANDARDFLAG && !Const.STARTERFLAG) || Const.LICENCE.SERVER_LIMITOFF_KDPANDID,
                id: this.id + 'idcount-text'
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
        if (this.grid && this.grid.rendered)
            this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        var kontekstfirmybox = Ext.getCmp(this.id + "kontekstfirmybox");
        if (AppFIRMACTX != null && !Const.AGGREGATEDCORE) {
            kontekstfirmybox.update("<div class='appSetColourRedSplit'></div>");
            kontekstfirmy.setText(Lang.pracujesz_w_kontekscie + AppFIRMACTX.nazwa);
        } else {
            kontekstfirmybox.update("");
            kontekstfirmy.setText("");
        }
        Ext.getCmp(this.id + "grupybtn").setDisabled(Const.ENTERPRISEFLAG && AppFIRMACTX == null)
        Ext.getCmp(this.id + "kategoriebtn").setDisabled(Const.ENTERPRISEFLAG && AppFIRMACTX == null)
        if (this.rebuildGrid) {
            this.rebuildGrid = false;
            Ext.suspendLayouts();
            var onwer = this.grid.ownerCt;
            onwer.remove(this.grid);
            this.taskContextMenu.destroy();
            this.buildGrid();
            onwer.add(this.grid);
            Ext.resumeLayouts(true);
            if (this.grid && this.grid.rendered)
                this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        }
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
        this.manageSelect();
    },
    scrollToView: function (id) {
        this.grid.selectRowScroll("id", id);
    },
    buildGrid: function () {
        var store = Ext.create('Ext.data.Store', {
            autoLoad: false,
            remoteSort: true,
            remoteFilter: true,
            pageSize: 50,
            model: Ext.define(null, {
                extend: 'Ext.data.Model',
                idProperty: 'id',
                fields: [{
                    name: 'id',
                    mapping: 'id'
                }, {
                    name: 'nazwa',
                    mapping: 'nazwa'
                }, {
                    name: 'active',
                    mapping: 'active'
                }, {
                    name: 'identyfikatorassigned',
                    mapping: 'identyfikatorassigned'
                }, {
                    name: 'firma',
                    mapping: 'firma'
                }, {
                    name: 'opis',
                    mapping: 'opis'
                }, {
                    name: "individualopts",
                    mapping: "individualopts"
                }, {
                    name: "eiid",
                    mapping: "eiid"
                }, {
                    name: "cardname",
                    mapping: "cardname"
                }, {
                    name: "rokprodukcji",
                    mapping: "rokprodukcji"
                }, {
                    name: "identeuro",
                    mapping: "identeuro"
                }, {
                    name: "fueltanklimit",
                    mapping: "fueltanklimit"
                }, {
                    name: "controlfueltanklimit",
                    mapping: "controlfueltanklimit"
                }, {
                    name: "canviewtankowanie",
                    mapping: "canviewtankowanie"
                }, {
                    name: "maxmileagediff",
                    mapping: "maxmileagediff"
                }, {
                    name: "askforvolumetank",
                    mapping: "askforvolumetank"
                }, {
                    name: "cansetaddpole",
                    mapping: "cansetaddpole"
                }, {
                    name: "ismotogodzinynotkilometry",
                    mapping: "ismotogodzinynotkilometry"
                }, {
                    name: "grupa",
                    mapping: "grupa"
                }, {
                    name: "grupaeiid",
                    mapping: "grupaeiid"
                }, {
                    name: "plyn",
                    mapping: "plyn"
                }, {
                    name: "zbiornikmobilny",
                    mapping: "zbiornikmobilny"
                }, {
                    name: "localization",
                    mapping: "localization"
                }, {
                    name: "typpojazdu",
                    mapping: "typpojazdu"
                }, {
                    name: "typtaboru",
                    mapping: "typtaboru"
                }, {
                    name: "markapojazdu",
                    mapping: "markapojazdu"
                }, {
                    name: "usercreate",
                    mapping: "usercreate"
                }, {
                    name: "userdeactivate",
                    mapping: "userdeactivate"
                }, {
                    name: "datecreate",
                    mapping: "datecreate"
                }, {
                    name: "datedeactivate",
                    mapping: "datedeactivate"
                }, {
                    name: "typwlasnosci",
                    mapping: "typwlasnosci"
                }, {
                    name: "kategoria",
                    mapping: "kategoria"
                }]
            }),
            proxy: {
                type: 'ajax',
                url: 'rest/pojazdy/getList',
                actionMethods: {
                    read: 'POST'
                },
                reader: {
                    type: 'json',
                    rootProperty: 'data',
                    totalProperty: 'total',
                    id: 'id'
                },
                filterParam: "filters",
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            listeners: {
                scope: this,
                load: handlGridLoadStoreCheckJsonRpcL
            },
            autoLoad: false
        });
        store.on("load", function (store) {
            Ext.defer(function () {
                var count = store.getTotalCount();
                var pageSize = store.getPageSize();
                var pageCount = Math.ceil(count / pageSize);
                var currentPage = store.currentPage;
                if (currentPage > pageCount && pageCount > 0) {
                    --store.currentPage;
                }
            }, 1000, this);
        }, this);
        var cols = [{
            header: "ID",
            width: 145,
            sortable: true,
            dataIndex: 'id',
            filter: {
                type: 'numeric'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.nazwa,
            flex: 2,
            sortable: true,
            dataIndex: 'nazwa',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.firma,
            flex: 2,
            sortable: true,
            dataIndex: 'firma',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: AppFIRMACTX != null
        }, {
            header: Lang.opis,
            flex: 2,
            sortable: true,
            dataIndex: 'opis',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.eiid,
            flex: 2,
            sortable: true,
            dataIndex: 'eiid',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || Ext.getViewportWidth() <= 1366
        }, {
            header: Lang.nazwa_karty,
            flex: 2,
            sortable: true,
            dataIndex: 'cardname',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.rok_produkcji,
            flex: 1,
            sortable: true,
            dataIndex: 'rokprodukcji',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.ident_euro,
            flex: 1,
            sortable: true,
            dataIndex: 'identeuro',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || Ext.getViewportWidth() <= 1366
        }, {
            header: Lang.pojemnosc_baku_paliwa,
            flex: 1,
            sortable: true,
            dataIndex: 'fueltanklimit',
            renderer: function (value) {
                return (value == null || value == 0) ? "" : value;
            },
            filter: {
                type: 'numeric'
            },
            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
            filterable: true
        }, {
            header: Lang.limit_pojemnosci_baku,
            flex: 1,
            sortable: true,
            dataIndex: 'controlfueltanklimit',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
            filterable: true
        }, {
            header: Lang.motogodziny,
            flex: 1,
            sortable: true,
            dataIndex: 'ismotogodzinynotkilometry',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            filterable: true,
            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
        }, {
            header: Lang.pole_dodatkowe_przy_tankowaniu,
            flex: 1,
            sortable: true,
            dataIndex: 'cansetaddpole',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.maksymalna_roznica_przebiegu,
            width: 100,
            sortable: true,
            dataIndex: 'maxmileagediff',
            filter: {
                type: 'numeric'
            },
            renderer: function (value) {
                return (value == null || value == 0) ? "" : value;
            },
            filterable: true
        }, {
            header: Lang.podglad_tankowania,
            flex: 1,
            sortable: true,
            dataIndex: 'canviewtankowanie',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            filterable: true,
            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
        }, {
            header: Lang.pytanie_o_ilosc_dozatankowania,
            flex: 1,
            sortable: true,
            dataIndex: 'askforvolumetank',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.ustawienia_indywidualne,
            flex: 1,
            sortable: true,
            dataIndex: 'individualopts',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.identyfikator,
            flex: 1,
            sortable: true,
            dataIndex: 'identyfikatorassigned',
            renderer: renderBool2,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.typ_pojazdu,
            flex: 2,
            sortable: true,
            dataIndex: 'typpojazdu',
            filterable: true,
            filter: {
                type: 'list',
                options: TYP_POJAZDU
            },
            hidden: !Const.ENABLETYCHY,
            renderer: function (value) {
                return TYP_POJAZDU.find(type => type[0] == value)[1]
            }
        }, {
            header: Lang.typ_wlasnosci,
            flex: 2,
            sortable: true,
            dataIndex: 'typwlasnosci',
            filterable: true,
            filter: {
                type: 'list',
                options: TYP_WLASNOSCI_POJAZDU
            },
            hidden: !Const.ENABLEKELLER || (!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyViewName) && !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyViewWynajemName)),
            renderer: function (value) {
                return TYP_WLASNOSCI_POJAZDU.find(type => type[0] == value)[1]
            }
        }, {
            header: Lang.typ_taboru,
            flex: 2,
            sortable: true,
            dataIndex: 'typtaboru',
            filterable: true,
            filter: {
                type: 'list',
                options: TYP_TABORU
            },
            hidden: !Const.ENABLETYCHY,
            renderer: function (value) {
                if (value == null) {
                    return "";
                }
                return TYP_TABORU.find(type => type[0] == value)[1];
            }
        }, {
            header: Lang.marka_pojazdu,
            flex: 2,
            sortable: true,
            dataIndex: 'markapojazdu',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: !Const.ENABLETYCHY
        }, {
            header2: Lang.active,
            menuText: Lang.active,
            header: Ext.DomHelper.markup({
                tag: "div",
                cls: "iconDivCol iconActive",
                cn: [{
                    tag: "span",
                    html: "&nbsp;"
                }, {
                    tag: "div",
                    html: Lang.active
                }]
            }),
            flex: 1,
            sortable: true,
            dataIndex: 'active',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.plyn_gps,
            flex: 2,
            sortable: true,
            dataIndex: 'plyn',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.zbiornik_mobilny,
            flex: 2,
            sortable: true,
            dataIndex: 'zbiornikmobilny',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.localization,
            flex: 2,
            sortable: true,
            dataIndex: 'localization',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.user_create,
            flex: 2,
            sortable: true,
            dataIndex: 'usercreate',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.user_deactivate,
            flex: 2,
            sortable: true,
            dataIndex: 'userdeactivate',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.data_utworzenia,
            flex: 3,
            sortable: true,
            dataIndex: 'datecreate',
            renderer: Ext.util.Format.dateRenderer(),
            filter: {
                type: 'date'
            },
            filterable: true
        }, {
            header: Lang.data_deaktywacji,
            flex: 3,
            sortable: true,
            dataIndex: 'datedeactivate',
            renderer: Ext.util.Format.dateRenderer(),
            filter: {
                type: 'date'
            },
            filterable: true
        }];
        this.groupStore = Ext.create('Ext.data.Store', {
            fields: [{
                name: 'id',
                mapping: 'id'
            }, {
                name: 'nazwa',
                mapping: 'nazwa'
            }, {
                name: 'eiid',
                mapping: 'eiid'
            }, {
                name: 'opis',
                mapping: 'opis'
            }, {
                name: 'adres',
                mapping: 'adres'
            }, {
                name: 'nip',
                mapping: 'nip'
            }],
            proxy: {
                type: "ajax",
                url: "rest/grupy/getList",
                actionMethods: {
                    read: "POST"
                },
                extraParams: {
                    type: Const.GROUP_TYPE_POJAZD
                },
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            listeners: {
                load: function () {
                    this.insert(0, [{
                        id: 0,
                        nazwa: Lang.brak_grupy
                    }]);
                }
            }
        });
        this.kategorieStore = Ext.create('Ext.data.Store', {
            fields: [{
                name: 'id',
                mapping: 'id'
            }, {
                name: 'nazwa',
                mapping: 'nazwa'
            }, {
                name: 'eiid',
                mapping: 'eiid'
            }, {
                name: 'opis',
                mapping: 'opis'
            }],
            proxy: {
                type: "ajax",
                url: "rest/kategorie/getList",
                actionMethods: {
                    read: "POST"
                },
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            listeners: {
                load: function () {
                    this.insert(0, [{
                        id: 0,
                        nazwa: Lang.brak_kategorii
                    }]);
                }
            }
        });
        if (!Const.STARTERFLAG) {
            cols.splice(4, 0, {
                header: Lang.grupa,
                id: this.id + 'grupacol',
                flex: 2,
                sortable: true,
                dataIndex: 'grupa',
                filter: {
                    type: 'list',
                    store: this.groupStore,
                    idField: 'id',
                    labelField: 'nazwa'
                },
                filterable: true,
                hidden: false
            });
        }
        if (!Const.STARTERFLAG) {
            cols.splice(4, 0, {
                header: Lang.kategoria,
                id: this.id + 'kategoriacol',
                flex: 2,
                sortable: true,
                dataIndex: 'kategoria',
                filter: {
                    type: 'list',
                    store: this.kategorieStore,
                    idField: 'id',
                    labelField: 'nazwa'
                },
                filterable: true,
                hidden: false
            });
        }
        if (Const.ENABLETYCHY) {
            cols.splice(5, 0, {
                header: Lang.grupa_eiid,
                id: this.id + 'grupaeiidcol',
                flex: 2,
                sortable: true,
                dataIndex: 'grupaeiid',
                filter: {
                    type: 'list',
                    store: this.groupStore,
                    idField: 'id',
                    labelField: 'eiid'
                },
                filterable: true,
                hidden: false
            });
        }
        if (!Const.ENTERPRISEFLAG) {
            removeObjectFromArrayById(cols, "firma");
        }
        if (Const.OPTIMALFLAG || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG) {
            removeObjectFromArrayById(cols, "cansetaddpole");
            removeObjectFromArrayById(cols, "askforvolumetank");
            removeObjectFromArrayById(cols, "individualopts");
            removeObjectFromArrayById(cols, "rokprodukcji");
            removeObjectFromArrayById(cols, "maxmileagediff");
            removeObjectFromArrayById(cols, "fueltanklimit");
            removeObjectFromArrayById(cols, "controlfueltanklimit");
        }
        if (Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG) {
            removeObjectFromArrayById(cols, "eiid");
            removeObjectFromArrayById(cols, "identeuro");
            removeObjectFromArrayById(cols, "ismotogodzinynotkilometry");
            removeObjectFromArrayById(cols, "canviewtankowanie");
            removeObjectFromArrayById(cols, "zbiornikmobilny");
        }
        if (!Const.ENABLEGPS || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG) {
            removeObjectFromArrayById(cols, "plyn");
        }
        if (!Const.ENABLEGIRTEKA && !Const.ENABLETRAMWAJE) {
            removeObjectFromArrayById(cols, "localization");
        }
        if (!Const.ENABLETYCHY) {
            removeObjectFromArrayById(cols, "typpojazdu");
            removeObjectFromArrayById(cols, "typtaboru");
            removeObjectFromArrayById(cols, "markapojazdu");
            removeObjectFromArrayById(cols, "userdeactivate");
            removeObjectFromArrayById(cols, "datedeactivate");
            removeObjectFromArrayById(cols, "datecreate");
            removeObjectFromArrayById(cols, "usercreate");
        }
        if (!Const.ENABLEKELLER) {
            removeObjectFromArrayById(cols, "typwlasnosci");
            removeObjectFromArrayById(cols, "cardname");
        }
        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true
            },
            store: store,
            columns: cols,
            frame: false,
            border: false,
            stateId: "this.grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'multi'
            },
            bbar: {
                xtype: 'pagingtoolbarexd',
                displayInfo: true,
                pagingStore: store
            }
        });
        this.grid.addListener("rowdblclick", function () {
            if (validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update") || validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/update"))
                if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
                } else {
                    var row = this.grid.getSelectionModel().getSelection()[0];
                    if (row != null) {
                        this.edytujObiekt();
                    }
                }
        }, this);
        this.grid.addListener("render", function () {
            this.manageSelect(this.grid.getSelectionModel());
        }, this);
        this.grid.store.addListener("load", function () {
            updateCzasRefreshSerwer();
        });
        this.grid.addListener("select", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.grid.addListener("selectionchange", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.taskContextMenu = new Ext.menu.Menu();
        this.taskContextMenu.add([{
            id: this.id + "bnew2",
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Const.ENABLEKELLER ? Lang.nowy_wlasny.capitalise() : Lang.nowy.capitalise(),
            scope: this,
            handler: this.dodajObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"),
        }, {
            id: this.id + "bnew2wynajem",
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Lang.nowy_wynajem.capitalise(),
            scope: this,
            hidden: !Const.ENABLEKELLER,
            handler: this.dodajObiektWynajem,
            disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add")
        }, {
            id: this.id + "bedit4",
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Lang.klonowanie.capitalise(),
            hidden: Const.CLOUDFLAG,
            scope: this,
            handler: this.edytujObiekt2,
            disabled: (!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add") && !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add")),
        }, {
            id: this.id + "bedit2",
            iconAlign: 'left',
            iconCls: "iconEdit",
            text: Lang.edytuj.capitalise(),
            scope: this,
            handler: this.edytujObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update") && !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/update")
        }, {
            id: this.id + "bdelete2",
            iconAlign: 'left',
            iconCls: "iconDelete",
            text: Lang.usun.capitalise(),
            scope: this,
            handler: this.usunObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/delete") || Const.ENABLEKELLER
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconPDF",
            text: Lang.pdf.capitalise(),
            scope: this,
            handler: this.getDownloadLsPdf
        }, {
            iconAlign: 'left',
            iconCls: "iconEXCEL",
            text: Lang.excel.capitalise(),
            scope: this,
            handler: this.getDownloadLsExcel
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconRefresh",
            text: Lang.odswiez.capitalise(),
            scope: this,
            handler: this.refreshDatastore
        }]);
        this.grid.addListener("rowcontextmenu", function (grid, record, tr, rowIndex, e) {
            this.rowContext = this.grid.getStore().getAt(rowIndex);
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
        this.taskContextMenu.addListener("hide", function () {
            this.rowContext = null;
        }, this);
        this.grid.addListener("containercontextmenu", function (grid, e) {
            this.rowContext = null;
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        var bdelete = Ext.getCmp(this.id + "bdelete");
        var bedit2 = Ext.getCmp(this.id + "bedit2");
        var bdelete2 = Ext.getCmp(this.id + "bdelete2");
        var bedit3 = Ext.getCmp(this.id + "bedit3");
        var bedit4 = Ext.getCmp(this.id + "bedit4");
        if (bedit != null) {
            if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
                bdelete.setDisabled(true);
                bedit.setDisabled(true);
                bedit3.setDisabled(true);
            } else {
                var row = this.grid.getSelectionModel().getSelection()[0];
                bdelete.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/delete"));
                bedit.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update"));
                bedit3.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
            }
            if (this.rowContext == null) {
                bdelete2.setDisabled(true);
                bedit2.setDisabled(true);
                bedit4.setDisabled(true);
            } else {
                bdelete2.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/delete"));
                bedit2.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/update"));
                bedit4.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
            }
            if (Const.ENABLEKELLER) {
                if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
                } else {
                    var row = this.grid.getSelectionModel().getSelection()[0];
                    if (row != null && row.data != null) {
                        var allowEdit = this.checkKeller(row.data.typwlasnosci)
                        bedit2.setDisabled(!allowEdit);
                        bedit.setDisabled(!allowEdit);
                    }
                }
                bdelete.setDisabled(bdelete.disabled || AppOPERATORHPOZIOM > 2);
                bdelete2.setDisabled(bdelete2.disabled || AppOPERATORHPOZIOM > 2);
                bedit3.setDisabled(true);
                bedit4.setDisabled(true);
            }
            var bnew = Ext.getCmp(this.id + "bnew");
            var bnewwynajem = Ext.getCmp(this.id + "bnewwynajem");
            var bnew2 = Ext.getCmp(this.id + "bnew2");
            var bnew2wynajem = Ext.getCmp(this.id + "bnew2wynajem");
            var masseditbtn = Ext.getCmp(this.id + "masseditbtn");
            if (Const.ENTERPRISEFLAG) {
                bnew.setDisabled(AppFIRMACTX == null || !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
                bnew2.setDisabled(AppFIRMACTX == null || !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
                bnewwynajem.setDisabled(AppFIRMACTX == null || !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add"));
                bnew2wynajem.setDisabled(AppFIRMACTX == null || !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add"));
                masseditbtn.setDisabled(AppFIRMACTX == null || !validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
            } else {
                bnew.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
                bnewwynajem.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add"));
                bnew2.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
                bnew2wynajem.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyWynajemName + "/add"));
                masseditbtn.setDisabled(!validPrivilegesOperatorComplex(ViewPojazdy.accessPropertyName + "/add"));
            }
        }
    },
    getDownloadLsPdf: function () {
        var defd = this.grid.getDefGridQueryCSF();
        postFormAsync("rest/pojazdy/downloadExportPdfOtherList", {
            format: "pdf",
            name: Lang.pojazdy,
            filters: defd.filters,
            sort: defd.sorters,
            defd: Ext.encode(defd)
        }, null);
    },
    getDownloadLsExcel: function () {
        var defd = this.grid.getDefGridQueryCSF();
        postFormAsync("rest/pojazdy/downloadExportPdfOtherList", {
            format: "excel",
            name: Lang.pojazdy,
            filters: defd.filters,
            sort: defd.sorters,
            defd: Ext.encode(defd)
        }, null);
    },
    refreshDatastore: function () {
        this.grid.store.load();
        if (Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG) {
            sendAjaxDataJsonRpcL("rest/systemreq/getActiveIDCount", null, this, function (data) {
                if (data.status) {
                    var tpl = Const.STARTERFLAG ? Lang.liczba_aktywnych_identyfikatorow_z_dostepnych_20 : Lang.liczba_aktywnych_identyfikatorow_z_dostepnych;
                    var idCountLabel = Ext.getCmp(this.id + 'idcount-text');
                    idCountLabel.setText(tpl.replace('{0}', data.data));
                    if (data.data >= (Const.STARTERGLAG ? 8 : 140)) {
                        idCountLabel.addCls('idcount-text-warning');
                    } else {
                        idCountLabel.removeCls('idcount-text-warning');
                    }
                } else {
                    Ext.MessageBox.alert(Lang.error, data.error);
                }
            });
        }
    },
    dodajObiekt: function () {
        windowObject = Ext.create('WindowPojazdy', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(0);
    },
    dodajObiektWynajem: function () {
        if (!validPrivilegesOperatorComplex("access.manage.pojazdy_wynajem")) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
        }
        windowObject = Ext.create('WindowPojazdy', {
            wynajem: true,
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(0);
    },
    edytujObiekt: function () {
        var id = 0;
        var typwlasnosci = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
                typwlasnosci = this.rowContext.typwlasnosci;
                if (!this.checkKeller(typwlasnosci)) {
                    Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
                    return;
                }
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length == 1) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
                typwlasnosci = this.grid.getSelectionModel().getSelection()[0].data.typwlasnosci;
                if (!this.checkKeller(typwlasnosci)) {
                    Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
                    return;
                }
            }
        }
        windowObject = Ext.create('WindowPojazdy', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(id);
    },
    massEdit: function () {
        windowObject = Ext.create('WindowMassEditSetProperties', {
            typ: Const.MASS_EDIT_TYPE_POJAZD
        });
        windowObject.showW(id);
        windowObject.on('closeSuccess', this.refreshDatastore, this);
    },
    showGrupy: function () {
        var window = Ext.create('WindowGroups', {
            type: Const.GROUP_TYPE_POJAZD
        });
        window.showW();
        window.on('closeSuccess', this.refreshDatastore, this);
    },
    showKategorie: function () {
        var window = Ext.create('WindowKategorie');
        window.showW();
        window.on('closeSuccess', this.refreshDatastore, this);
    },
    edytujObiekt2: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        this.windowObject = Ext.create('WindowPojazdy', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.showW(id, true);
    },
    checkKeller: function (typwlasnosci) {
        var res = false;
        if (Const.ENABLEKELLER) {
            if (typwlasnosci == Const.TYP_WLASNOSCI_POJAZDU_WLASNY) {
                res = validPrivilegesOperatorComplex("access.manage.pojazdy");
            }
            if (typwlasnosci == Const.TYP_WLASNOSCI_POJAZDU_WYNAJEM) {
                res = validPrivilegesOperatorComplex("access.manage.pojazdy_wynajem");
            }
        } else {
            return validPrivilegesOperatorComplex("access.manage.pojazdy");
        }
        return res;
    },
    usunObiekt: function () {
        var ids = [];
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                ids = [this.rowContext.id];
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                Ext.each(this.grid.getSelectionModel().getSelection(), function (v) {
                    ids.push(v.id);
                });
            }
        }
        Ext.MessageBox.show({
            title: Lang.usuwanie,
            msg: Lang.czy_napewno_usunac_obiekt,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "yes") {
                    sendAjaxDataJsonRpcL("rest/pojazdy/deleteObject", {
                        ids: ids
                    }, this, function (data) {
                        if (data.status) {
                        } else {
                            Ext.MessageBox.alert(Lang.error, data.error);
                        }
                        this.refreshDatastore();
                    });
                }
            }
        });
    }
});
